// 事件分類的線條圖示（ls-loop 2026-10-11 外觀翻新）：取代首頁統計、事件縮圖裡的 emoji（🏃🧍🚗…），
// 跟側欄 NavIcon 同一種線稿風格；stroke=currentColor，大小由外層 CSS 決定。aria-hidden（旁邊有文字）。
import type { JSX } from 'react';
import type { ClusterKey } from '../features/events/eventsLib';

const PATHS: Record<ClusterKey, JSX.Element> = {
  // 移動：兩道動態線 + 箭頭
  motion: (
    <>
      <path d="M4 8h9" />
      <path d="M2 12h11" />
      <path d="M4 16h9" />
      <path d="M15 7l5 5-5 5" />
    </>
  ),
  // 人
  person: (
    <>
      <circle cx="12" cy="6.5" r="3" />
      <path d="M6 21v-4.5A4.5 4.5 0 0 1 10.5 12h3a4.5 4.5 0 0 1 4.5 4.5V21" />
    </>
  ),
  // 車
  vehicle: (
    <>
      <path d="M3 16v-4l2.2-5h13.6L21 12v4" />
      <path d="M3 12h18" />
      <circle cx="7.5" cy="17" r="2" />
      <circle cx="16.5" cy="17" r="2" />
    </>
  ),
  // 動物：腳印
  animal: (
    <>
      <circle cx="12" cy="16" r="3.5" />
      <circle cx="6" cy="10" r="1.8" />
      <circle cx="10" cy="6.5" r="1.8" />
      <circle cx="14" cy="6.5" r="1.8" />
      <circle cx="18" cy="10" r="1.8" />
    </>
  ),
  // 包裹
  package: (
    <>
      <path d="M3 8l9-5 9 5v8l-9 5-9-5z" />
      <path d="M3 8l9 5 9-5" />
      <path d="M12 13v8" />
    </>
  ),
  // 物件（未分類）：取景框
  object: (
    <>
      <path d="M4 8V5a1 1 0 0 1 1-1h3" />
      <path d="M16 4h3a1 1 0 0 1 1 1v3" />
      <path d="M20 16v3a1 1 0 0 1-1 1h-3" />
      <path d="M8 20H5a1 1 0 0 1-1-1v-3" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  // 聲音
  sound: (
    <>
      <path d="M4 9v6h4l5 4V5L8 9z" />
      <path d="M16.5 8.5a5 5 0 0 1 0 7" />
      <path d="M19 6a8.5 8.5 0 0 1 0 12" />
    </>
  ),
  // 門鈴
  doorbell: (
    <>
      <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </>
  ),
  // 其他
  other: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v5" />
      <path d="M12 16.5v.01" />
    </>
  ),
};

export function ClusterIcon({ kind, size = 22 }: { kind: ClusterKey; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[kind] ?? PATHS.other}
    </svg>
  );
}
